import React, { useEffect, useRef } from 'react'
import { StyleMessageListWrapper } from '../style'
import { useSelector } from 'react-redux'
import MessageItem from './item'

const MessageLists = () => {
  const scrollRef = useRef<HTMLDivElement | any>(null)

  const { items } = useSelector((state: any) => state.supportMessages)

  const chats = [
    {
      senderId: '0',
      receiverId: '1',
      message: 'Hey! How are you?',
      time: '10:00 AM',
      imgsrc: [],
    },
    {
      senderId: '1',
      receiverId: '0',
      message: 'Hi! I’m good, how about you?',
      time: '10:01 AM',
      imgsrc: [],
    },
    {
      senderId: '0',
      receiverId: '1',
      message: 'Doing great, just working on a project.',
      time: '10:02 AM',
      imgsrc: [],
    },
    {
      senderId: '1',
      receiverId: '0',
      message: 'Nice! What kind of project?',
      time: '10:03 AM',
      imgsrc: [],
    },
    {
      senderId: '0',
      receiverId: '1',
      message: 'It’s a real-time chat app using Socket.io.',
      time: '10:04 AM',
      imgsrc: [],
    },
    {
      senderId: '1',
      receiverId: '0',
      message: 'Sounds cool! Let me know if you need help.',
      time: '10:05 AM',
      imgsrc: [],
    },
    {
      senderId: '0',
      receiverId: '1',
      message: 'Sure, thanks a lot!',
      time: '10:06 AM',
      imgsrc: [],
    },
  ]

  const allChats = [...chats, ...items]
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight
    }
  }, [items.length])
  return (
    <StyleMessageListWrapper ref={scrollRef}>
      <MessageItem chats={allChats} />
    </StyleMessageListWrapper>
  )
}

export default MessageLists
